import { render } from "./AddressViewer.vue?vue&type=template&id=0e55b8ee"
import script from "./AddressViewer.vue?vue&type=script&lang=js"
export * from "./AddressViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__